exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specs-column .spec-item__category {\n  width: 90px;\n  color: #444259;\n  font-size: 14px;\n  font-weight: bold;\n  flex-shrink: 0;\n  margin-right: 12px;\n}", ""]);

// exports
